/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Hda8Inputs */

const en__field_enum_icsrm_hda8 = /** @type {(inputs: _Field_Enum_Icsrm_Hda8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmstadt University of Applied Sciences`)
};

const de__field_enum_icsrm_hda8 = /** @type {(inputs: _Field_Enum_Icsrm_Hda8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule Darmstadt`)
};

/**
* | output |
* | --- |
* | "Darmstadt University of Applied Sciences" |
*
* @param {_Field_Enum_Icsrm_Hda8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_hda8 = /** @type {((inputs?: _Field_Enum_Icsrm_Hda8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Hda8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_hda8(inputs)
	return de__field_enum_icsrm_hda8(inputs)
});
export { _field_enum_icsrm_hda8 as "_field_enum_ICSRM_HDA" }